(function () {
  'use strict';

  // Escapa texto antes de inserir em HTML montado por string (nomes de produto, fretes etc.).
  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Raiz das rotas da loja (considera prefixo de idioma, ex.: /en/).
  function route(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/?$/, '/') + path.replace(/^\//, '');
  }

  function shuffleItems() {
    if (window.Shopify && window.Shopify.designMode) return;
    var containers = document.querySelectorAll('.mm-shuffle-items');
    Array.prototype.forEach.call(containers, function (container) {
      var items = Array.prototype.slice.call(container.children);
      if (items.length < 2) return;
      for (var i = items.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = items[i];
        items[i] = items[j];
        items[j] = tmp;
      }
      items.forEach(function (item) {
        container.appendChild(item);
      });
    });
  }

  function initReveal() {
    var targets = document.querySelectorAll('.mm-reveal');
    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0, rootMargin: '0px 0px -8% 0px' }
    );
    targets.forEach(function (el) { observer.observe(el); });
  }

  function initHeader() {
    var header = document.querySelector('.mm-header');
    if (!header) return;
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  var MAX_DOTS = 10;

  if (!customElements.get('mm-carousel')) {
    customElements.define(
      'mm-carousel',
      class MMCarousel extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.mm-track');
          if (!this.track) return;
          this.prevBtn = this.querySelector('.mm-nav--prev');
          this.nextBtn = this.querySelector('.mm-nav--next');
          this.dotsWrap = this.querySelector('.mm-dots');
          if (this.prevBtn) this.prevBtn.addEventListener('click', this.scrollByPage.bind(this, -1));
          if (this.nextBtn) this.nextBtn.addEventListener('click', this.scrollByPage.bind(this, 1));
          if (this.dotsWrap) this.buildDots();
          this.track.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
          if (this.hasAttribute('autoplay')) this.startAutoplay();
        }

        disconnectedCallback() {
          this.stopAutoplay();
        }

        get slides() {
          return Array.prototype.slice.call(this.track.children);
        }

        scrollByPage(direction) {
          var amount = this.hasAttribute('paged')
            ? this.track.clientWidth
            : this.track.clientWidth * 0.8;
          var max = this.track.scrollWidth - this.track.clientWidth;
          var next = this.track.scrollLeft + direction * amount;
          if (direction > 0 && this.track.scrollLeft >= max - 4) next = 0;
          if (direction < 0 && this.track.scrollLeft <= 4) next = max;
          this.track.scrollTo({ left: next, behavior: 'smooth' });
        }

        currentIndex() {
          var width = this.slides[0] ? this.slides[0].offsetWidth : this.track.clientWidth;
          return Math.round(this.track.scrollLeft / Math.max(width, 1));
        }

        buildDots() {
          var self = this;
          this.dotsWrap.innerHTML = '';
          // Muitos slides (produto com 75 fotos): 75 bolinhas passavam de
          // 1300px e alargavam a pagina inteira no celular. Vira contador "1 / 75".
          if (this.slides.length > MAX_DOTS) {
            this.dotsWrap.classList.add('mm-dots--count');
            this.counter = document.createElement('span');
            this.counter.className = 'mm-dots__count';
            this.counter.setAttribute('aria-live', 'polite');
            this.dotsWrap.appendChild(this.counter);
            this.updateDots();
            return;
          }
          this.dotsWrap.classList.remove('mm-dots--count');
          this.counter = null;
          this.slides.forEach(function (slide, index) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.setAttribute('aria-label', 'Ir para o slide ' + (index + 1));
            dot.addEventListener('click', function () {
              self.track.scrollTo({ left: slide.offsetLeft - self.track.offsetLeft, behavior: 'smooth' });
            });
            self.dotsWrap.appendChild(dot);
          });
          this.updateDots();
        }

        updateDots() {
          if (!this.dotsWrap) return;
          var current = this.currentIndex();
          if (this.counter) {
            this.counter.textContent = Math.min(current + 1, this.slides.length) + ' / ' + this.slides.length;
            return;
          }
          Array.prototype.forEach.call(this.dotsWrap.children, function (dot, index) {
            dot.setAttribute('aria-current', index === current ? 'true' : 'false');
          });
        }

        onScroll() {
          var self = this;
          window.clearTimeout(this.scrollTimer);
          this.scrollTimer = window.setTimeout(function () { self.updateDots(); }, 80);
        }

        startAutoplay() {
          var self = this;
          var interval = parseInt(this.getAttribute('autoplay'), 10) || 6000;
          var media = window.matchMedia('(prefers-reduced-motion: reduce)');
          if (media.matches) return;
          this.timer = window.setInterval(function () { self.scrollByPage(1); }, interval);
          this.addEventListener('pointerenter', this.stopAutoplay.bind(this));
          this.addEventListener('pointerleave', function () {
            if (!self.timer) self.timer = window.setInterval(function () { self.scrollByPage(1); }, interval);
          });
        }

        stopAutoplay() {
          if (this.timer) {
            window.clearInterval(this.timer);
            this.timer = null;
          }
        }
      }
    );
  }

  function initMobileMenu() {
    var burger = document.querySelector('.mm-header__burger');
    var drawer = document.getElementById('mm-drawer');
    if (!burger || !drawer) return;
    var panel = drawer.querySelector('.mm-drawer__panel');
    var closers = drawer.querySelectorAll('.mm-drawer__overlay, .mm-drawer__close');
    var closeTimer;

    function open() {
      window.clearTimeout(closeTimer);
      drawer.hidden = false;
      document.body.style.overflow = 'hidden';
      burger.setAttribute('aria-expanded', 'true');
      window.requestAnimationFrame(function () {
        drawer.classList.add('is-open');
      });
      var firstLink = panel.querySelector('a, button');
      if (firstLink) firstLink.focus();
    }

    function close() {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
      burger.setAttribute('aria-expanded', 'false');
      closeTimer = window.setTimeout(function () {
        drawer.hidden = true;
      }, 300);
      burger.focus();
    }

    burger.addEventListener('click', open);
    closers.forEach(function (el) {
      el.addEventListener('click', close);
    });
    drawer.addEventListener('click', function (event) {
      if (event.target.closest('a')) close();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !drawer.hidden) close();
    });
  }

  function initHeroVideo() {
    var videos = document.querySelectorAll('.mm-hero__video');
    Array.prototype.forEach.call(videos, function (video) {
      var slide = video.closest('.mm-hero__slide');
      if (!slide) return;
      var reveal = function () {
        slide.classList.add('is-video-ready');
      };
      if (video.readyState >= 3) reveal();
      video.addEventListener('loadeddata', reveal);
      video.addEventListener('playing', reveal);
      video.addEventListener('canplaythrough', reveal);
      var attempt = video.play && video.play();
      if (attempt && attempt.catch) attempt.catch(function () {});
    });
  }

  var MMCart = (function () {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'BRL';

    function money(cents) {
      try {
        return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: currency }).format(cents / 100);
      } catch (e) {
        return 'R$ ' + (cents / 100).toFixed(2);
      }
    }

    function drawer() { return document.getElementById('mm-cart-drawer'); }

    function updateCount(count) {
      var icon = document.querySelector('.mm-header__icon[aria-label="Sacola de compras"]');
      if (!icon) return;
      var badge = icon.querySelector('.mm-header__count');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'mm-header__count';
          badge.setAttribute('aria-hidden', 'true');
          icon.appendChild(badge);
        }
        badge.textContent = count;
      } else if (badge) {
        badge.remove();
      }
    }

    // Barra "faltam R$ X para frete gratis" (snippets/mm-free-shipping-bar.liquid).
    function updateFreeShipping(cart) {
      document.querySelectorAll('[data-mm-fs]').forEach(function (bar) {
        var min = parseInt(bar.getAttribute('data-threshold'), 10) || 0;
        if (!min) return;
        var region = bar.getAttribute('data-region') || '';
        var left = min - cart.total_price;
        var pct = Math.max(0, Math.min(100, Math.floor((cart.total_price * 100) / min)));
        var where = region ? ' ' + esc(region) : '';
        var msg = bar.querySelector('[data-mm-fs-msg]');
        var fill = bar.querySelector('[data-mm-fs-fill]');
        var track = bar.querySelector('[data-mm-fs-track]');
        bar.hidden = cart.item_count === 0;
        bar.classList.toggle('is-done', left <= 0);
        if (msg) {
          msg.innerHTML = left <= 0
            ? 'Você ganhou <strong>frete grátis</strong>' + where + '!'
            : 'Faltam <strong>' + money(left) + '</strong> para ganhar <strong>frete grátis</strong>' + where;
        }
        if (fill) fill.style.width = pct + '%';
        if (track) track.setAttribute('aria-valuenow', String(pct));
      });
      if (MMSuggest) MMSuggest.update(cart);
    }

    function render(cart) {
      updateFreeShipping(cart);
      var items = document.getElementById('mm-cd-items');
      var empty = document.getElementById('mm-cd-empty');
      var foot = document.getElementById('mm-cd-foot');
      var subtotal = document.getElementById('mm-cd-subtotal');
      if (!items) return;
      updateCount(cart.item_count);
      if (cart.item_count === 0) {
        items.innerHTML = '';
        if (empty) empty.hidden = false;
        if (foot) foot.hidden = true;
        return;
      }
      if (empty) empty.hidden = true;
      if (foot) foot.hidden = false;
      if (subtotal) subtotal.textContent = money(cart.total_price);
      var html = '';
      cart.items.forEach(function (item) {
        html += '<div class="mm-cd__item">'
          + '<a class="mm-cd__item-img" href="' + esc(item.url) + '">' + (item.image ? '<img src="' + esc(item.image) + '" alt="" loading="lazy">' : '') + '</a>'
          + '<div>'
            + '<a class="mm-cd__item-name" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>'
            + (item.variant_title ? '<span class="mm-cd__item-variant">' + esc(item.variant_title) + '</span>' : '')
            + '<span class="mm-cd__item-qty">'
              + '<button type="button" data-key="' + esc(item.key) + '" data-q="' + (item.quantity - 1) + '" aria-label="Diminuir">&minus;</button>'
              + '<span>' + item.quantity + '</span>'
              + '<button type="button" data-key="' + esc(item.key) + '" data-q="' + (item.quantity + 1) + '" aria-label="Aumentar">+</button>'
            + '</span>'
          + '</div>'
          + '<div class="mm-cd__item-right">'
            + '<span class="mm-cd__item-price">' + money(item.final_line_price) + '</span>'
            + '<button type="button" class="mm-cd__item-remove" data-key="' + esc(item.key) + '" data-q="0">Remover</button>'
          + '</div>'
        + '</div>';
      });
      items.innerHTML = html;
    }

    function fetchCart() {
      return fetch(route('cart.js'), { headers: { 'Accept': 'application/json' } })
        .then(function (r) {
          if (!r.ok) throw new Error('cart ' + r.status);
          return r.json();
        });
    }

    function open() {
      var d = drawer();
      if (!d) return;
      d.hidden = false;
      document.body.style.overflow = 'hidden';
      window.requestAnimationFrame(function () { d.classList.add('is-open'); });
    }

    function close() {
      var d = drawer();
      if (!d) return;
      d.classList.remove('is-open');
      document.body.style.overflow = '';
      window.setTimeout(function () { d.hidden = true; }, 300);
    }

    function refresh(shouldOpen) {
      return fetchCart().then(function (cart) {
        render(cart);
        if (shouldOpen) open();
        return cart;
      });
    }

    function add(form, btn) {
      var data = new FormData(form);
      if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Adicionando...'; }
      return fetch(route('cart/add.js'), { method: 'POST', headers: { 'Accept': 'application/json' }, body: data })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Adicionar à sacola'; }
          if (!res.ok) {
            alert(res.body && res.body.description ? res.body.description : 'Não foi possível adicionar. Tente novamente.');
            return;
          }
          return refresh(true);
        })
        .catch(function () {
          if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Adicionar à sacola'; }
        });
    }

    var changing = false;
    function change(key, qty) {
      if (changing) return Promise.resolve();
      changing = true;
      var items = document.getElementById('mm-cd-items');
      if (items) items.setAttribute('aria-busy', 'true');
      return fetch(route('cart/change.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
        .then(function (res) {
          if (!res.ok || !res.body || !res.body.items) {
            alert((res.body && res.body.description) || 'Não foi possível atualizar a sacola. Tente novamente.');
            return refresh(false);
          }
          render(res.body);
          return res.body;
        })
        .catch(function () { return refresh(false).catch(function () {}); })
        .then(function (cart) {
          changing = false;
          if (items) items.removeAttribute('aria-busy');
          return cart;
        });
    }

    return { open: open, close: close, add: add, change: change, refresh: refresh };
  })();

  // ---- Sugestao para completar o frete gratis -------------------------------
  // Quando falta valor para o frete gratis, sugere ate 3 pecas relacionadas as
  // da sacola (recomendacoes do Shopify) que tenham o MESMO tamanho da sacola
  // (ou tamanho unico) e preco que cobre o que falta com a menor sobra. Um
  // toque adiciona; a foto abre uma espiada (modal) sem sair do carrinho.
  // Sem candidata boa, nao mostra nada.
  var MMSuggest = (function () {
    var SIZE_NAME = /^(tamanho|tamanhos|size)$/i;
    var ONE_SIZE = /^(u|un|unico|único|tu|tam unico|tamanho unico)$/i;
    var recsCache = {};
    var lastKey = '';
    var current = [];
    var busy = false;

    function money(cents) {
      try { return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(cents / 100); }
      catch (e) { return 'R$ ' + (cents / 100).toFixed(2); }
    }
    function bar() { return document.querySelector('[data-mm-fs]'); }
    function enabled() { var b = bar(); return Boolean(b && b.getAttribute('data-suggest') === 'true'); }
    function threshold() { var b = bar(); return b ? parseInt(b.getAttribute('data-threshold'), 10) || 0 : 0; }
    function containers() { return document.querySelectorAll('[data-mm-fs-suggest]'); }

    // Tamanhos da sacola, da peca mais recente para a mais antiga.
    function cartSizes(cart) {
      var sizes = [];
      cart.items.forEach(function (item) {
        (item.options_with_values || []).forEach(function (o) {
          if (SIZE_NAME.test(o.name) && sizes.indexOf(o.value) < 0) sizes.push(o.value);
        });
      });
      return sizes;
    }

    function recs(productId) {
      if (recsCache[productId]) return recsCache[productId];
      recsCache[productId] = fetch(route('recommendations/products.json') + '?product_id=' + productId + '&limit=10&intent=related', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (j) { return j.products || []; })
        .catch(function () { return []; });
      return recsCache[productId];
    }

    // Melhor variante de cada produto: disponivel, mesmo tamanho (ou unico) e
    // preco >= o que falta, com a menor sobra.
    function pick(products, cart, left, sizes) {
      var inCart = {};
      cart.items.forEach(function (i) { inCart[i.product_id] = true; });
      var seen = {};
      var out = [];
      products.forEach(function (p) {
        if (!p || inCart[p.id] || seen[p.id]) return;
        seen[p.id] = true;
        var names = (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
        var sizeIdx = -1;
        names.forEach(function (n, i) { if (SIZE_NAME.test(n)) sizeIdx = i; });
        var best = null;
        (p.variants || []).forEach(function (v) {
          if (!v.available || v.price < left) return;
          var size = sizeIdx >= 0 ? v.options[sizeIdx] : '';
          var fits = sizeIdx < 0 || ONE_SIZE.test(size) || sizes.indexOf(size) >= 0;
          if (!fits) return;
          var rank = sizeIdx < 0 || ONE_SIZE.test(size) ? sizes.length : sizes.indexOf(size);
          if (!best || v.price - left < best.over || (v.price - left === best.over && rank < best.rank)) {
            best = { product: p, variant: v, over: v.price - left, rank: rank, size: sizeIdx >= 0 ? size : '', sizeIdx: sizeIdx };
          }
        });
        if (best) out.push(best);
      });
      out.sort(function (a, b) { return a.over - b.over || a.rank - b.rank; });
      return out.slice(0, 3);
    }

    // Fotos do Shopify sao quadradas com laterais brancas: o CDN devolve ja
    // recortada em 3:4 no centro (sem o branco), como a galeria do produto.
    function img(src, width) {
      if (!src) return '';
      src = src.replace(/^http:/, 'https:');
      return src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=' + width + '&height=' + Math.round(width * 4 / 3) + '&crop=center';
    }
    function variantImage(s) {
      var v = s.variant;
      return (v.featured_image && v.featured_image.src) || s.product.featured_image || (s.product.images || [])[0] || '';
    }
    function sizeLabel(s) {
      return !s.size || ONE_SIZE.test(s.size) ? 'Tam. único' : 'Tam. ' + s.size;
    }

    function render(left) {
      var html = '';
      if (current.length) {
        html = '<p class="mm-sug__title">Falta pouco! Complete com uma destas e ganhe <strong>frete grátis</strong>:</p>'
          + '<div class="mm-sug__list">'
          + current.map(function (s, i) {
            return '<div class="mm-sug__card">'
              + '<button type="button" class="mm-sug__img" data-sug-view="' + i + '" aria-label="Ver fotos de ' + esc(s.product.title) + '">'
                + '<img src="' + esc(img(variantImage(s), 240)) + '" alt="">'
                + '<span class="mm-sug__zoom" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="6"/><path d="m20 20-4.5-4.5M11 8v6M8 11h6"/></svg></span>'
              + '</button>'
              + '<div class="mm-sug__info">'
                + '<button type="button" class="mm-sug__name" data-sug-view="' + i + '">' + esc(s.product.title) + '</button>'
                + '<span class="mm-sug__meta"><strong>' + money(s.variant.price) + '</strong> · ' + esc(sizeLabel(s)) + '</span>'
                + '<button type="button" class="mm-sug__add" data-sug-add="' + i + '">+ Adicionar</button>'
              + '</div>'
            + '</div>';
          }).join('')
          + '</div>';
      }
      Array.prototype.forEach.call(containers(), function (c) {
        c.innerHTML = html;
        c.hidden = !html;
      });
    }

    function update(cart) {
      if (!containers().length) return;
      var min = threshold();
      var left = min - cart.total_price;
      if (!enabled() || !cart.item_count || !min || left <= 0) {
        current = [];
        lastKey = '';
        render(0);
        return;
      }
      var sizes = cartSizes(cart);
      var key = left + '|' + cart.items.map(function (i) { return i.variant_id + 'x' + i.quantity; }).join(',');
      if (key === lastKey) return;
      lastKey = key;
      var ids = [];
      cart.items.forEach(function (i) { if (ids.indexOf(i.product_id) < 0 && ids.length < 3) ids.push(i.product_id); });
      Promise.all(ids.map(recs)).then(function (lists) {
        if (key !== lastKey) return; // a sacola mudou enquanto buscava
        current = pick([].concat.apply([], lists), cart, left, sizes);
        render(left);
      });
    }

    function addVariant(id, btn) {
      if (busy) return Promise.resolve();
      busy = true;
      if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Adicionando...'; }
      return fetch(route('cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.body && res.body.description) || 'Não foi possível adicionar.');
          closeView();
          // Pagina da sacola e renderizada no servidor: recarrega. Na gaveta,
          // o MMCart redesenha (barra fica verde e as sugestoes somem).
          if (document.querySelector('.mm-cart [data-mm-fs-suggest]')) { window.location.reload(); return; }
          return MMCart.refresh(false);
        })
        .catch(function (err) {
          alert(err.message || 'Não foi possível adicionar. Tente novamente.');
          if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || '+ Adicionar'; }
        })
        .then(function () { busy = false; });
    }

    // ---- Espiada (modal) ----
    var view = null;
    var viewing = null;
    var lastFocus = null;

    function ensureView() {
      if (view) return view;
      view = document.createElement('div');
      view.className = 'mm-qv';
      view.hidden = true;
      view.innerHTML = '<button type="button" class="mm-qv__overlay" aria-label="Fechar" tabindex="-1"></button>'
        + '<div class="mm-qv__panel" role="dialog" aria-modal="true" aria-labelledby="mm-qv-title">'
          + '<button type="button" class="mm-qv__close" aria-label="Fechar"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"/></svg></button>'
          + '<div class="mm-qv__media" id="mm-qv-media"></div>'
          + '<div class="mm-qv__count" id="mm-qv-count" aria-live="polite"></div>'
          + '<div class="mm-qv__body">'
            + '<h3 class="mm-qv__title" id="mm-qv-title"></h3>'
            + '<div class="mm-qv__price" id="mm-qv-price"></div>'
            + '<div class="mm-qv__opts" id="mm-qv-opts"></div>'
            + '<a class="mm-qv__link" id="mm-qv-link" href="#">Ver página completa da peça</a>'
          + '</div>'
          + '<div class="mm-qv__foot"><div class="mm-qv__sum" id="mm-qv-sum"></div><button type="button" class="mm-btn mm-btn--red mm-qv__add" id="mm-qv-add">Adicionar e ganhar frete grátis</button></div>'
        + '</div>';
      document.body.appendChild(view);
      view.querySelector('.mm-qv__overlay').addEventListener('click', closeView);
      view.querySelector('.mm-qv__close').addEventListener('click', closeView);
      view.querySelector('#mm-qv-add').addEventListener('click', function () {
        if (viewing) addVariant(viewing.variant.id, this);
      });
      var media = view.querySelector('#mm-qv-media');
      media.addEventListener('scroll', function () {
        var n = media.children.length;
        var i = Math.round(media.scrollLeft / Math.max(media.clientWidth, 1));
        view.querySelector('#mm-qv-count').textContent = n > 1 ? (i + 1) + ' / ' + n : '';
      }, { passive: true });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && view && !view.hidden) closeView();
      });
      return view;
    }

    function fillView() {
      var s = viewing;
      var v = ensureView();
      var p = s.product;
      var imgs = (p.images || []).slice();
      var first = variantImage(s);
      if (first) imgs = [first].concat(imgs.filter(function (u) { return u.split('?')[0] !== first.split('?')[0]; }));
      imgs = imgs.slice(0, 12);
      v.querySelector('#mm-qv-media').innerHTML = imgs.map(function (u, k) { return '<img src="' + esc(img(u, 720)) + '" alt=""' + (k ? ' loading="lazy"' : ' fetchpriority="high"') + '>'; }).join('');
      v.querySelector('#mm-qv-media').scrollLeft = 0;
      v.querySelector('#mm-qv-count').textContent = imgs.length > 1 ? '1 / ' + imgs.length : '';
      v.querySelector('#mm-qv-title').textContent = p.title;
      v.querySelector('#mm-qv-price').innerHTML = '<strong>' + money(s.variant.price) + '</strong>'
        + (s.variant.compare_at_price > s.variant.price ? ' <s>' + money(s.variant.compare_at_price) + '</s>' : '');
      // Outras cores no mesmo tamanho que tambem garantem o frete gratis.
      var names = (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
      var colorIdx = -1;
      names.forEach(function (n, i) { if (/^(cor|cores|color)$/i.test(n)) colorIdx = i; });
      var opts = '';
      if (colorIdx >= 0) {
        var left = threshold() - (s.cartTotal || 0);
        var alts = (p.variants || []).filter(function (x) {
          return x.available && x.price >= left && (s.sizeIdx < 0 || x.options[s.sizeIdx] === s.variant.options[s.sizeIdx]);
        });
        if (alts.length > 1) {
          opts += '<span class="mm-qv__label">Cor</span><div class="mm-qv__chips">'
            + alts.map(function (x) {
              return '<button type="button" class="mm-qv__chip' + (x.id === s.variant.id ? ' is-on' : '') + '" data-qv-variant="' + x.id + '" aria-pressed="' + (x.id === s.variant.id) + '">' + esc(x.options[colorIdx]) + '</button>';
            }).join('') + '</div>';
        } else {
          opts += '<span class="mm-qv__label">Cor: <strong>' + esc(s.variant.options[colorIdx]) + '</strong></span>';
        }
      }
      opts += '<span class="mm-qv__label">' + (!s.size || ONE_SIZE.test(s.size) ? 'Tamanho único' : 'Tamanho <strong>' + esc(s.size) + '</strong> · o mesmo da sua sacola') + '</span>';
      v.querySelector('#mm-qv-opts').innerHTML = opts;
      Array.prototype.forEach.call(v.querySelectorAll('[data-qv-variant]'), function (b) {
        b.addEventListener('click', function () {
          var id = parseInt(b.getAttribute('data-qv-variant'), 10);
          var nv = (p.variants || []).filter(function (x) { return x.id === id; })[0];
          if (nv) { viewing = Object.assign({}, viewing, { variant: nv }); fillView(); }
        });
      });
      v.querySelector('#mm-qv-link').href = p.url || ('/products/' + p.handle);
      // Resumo fixo junto do botao: preco, tamanho e cor sempre a vista.
      v.querySelector('#mm-qv-sum').innerHTML = '<strong>' + money(s.variant.price) + '</strong> · ' + esc(sizeLabel(s))
        + (colorIdx >= 0 ? ' · ' + esc(s.variant.options[colorIdx]) : '');
      var add = v.querySelector('#mm-qv-add');
      add.disabled = false;
      add.textContent = 'Adicionar e ganhar frete grátis';
    }

    function openView(i, cartTotal) {
      if (!current[i]) return;
      viewing = Object.assign({}, current[i], { cartTotal: cartTotal });
      lastFocus = document.activeElement;
      fillView();
      view.hidden = false;
      document.documentElement.classList.add('mm-qv-open');
      window.requestAnimationFrame(function () { view.classList.add('is-open'); });
      view.querySelector('.mm-qv__close').focus();
    }

    function closeView() {
      if (!view || view.hidden) return;
      view.classList.remove('is-open');
      document.documentElement.classList.remove('mm-qv-open');
      window.setTimeout(function () { view.hidden = true; }, 250);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    var lastCartTotal = 0;
    function init() {
      document.addEventListener('click', function (e) {
        var addBtn = e.target.closest('[data-sug-add]');
        if (addBtn) {
          var s = current[parseInt(addBtn.getAttribute('data-sug-add'), 10)];
          if (s) addVariant(s.variant.id, addBtn);
          return;
        }
        var viewBtn = e.target.closest('[data-sug-view]');
        if (viewBtn) openView(parseInt(viewBtn.getAttribute('data-sug-view'), 10), lastCartTotal);
      });
      // Pagina da sacola: busca o carrinho uma vez (a gaveta atualiza via MMCart).
      if (document.querySelector('.mm-cart [data-mm-fs-suggest]')) {
        fetch(route('cart.js'), { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) { lastCartTotal = cart.total_price; update(cart); })
          .catch(function () {});
      }
    }

    return {
      init: init,
      update: function (cart) { lastCartTotal = cart.total_price; update(cart); }
    };
  })();

  function initCart() {
    var d = document.getElementById('mm-cart-drawer');
    if (!d) return;

    d.querySelectorAll('.mm-cd__overlay, .mm-cd__close').forEach(function (el) {
      el.addEventListener('click', MMCart.close);
    });
    var items = document.getElementById('mm-cd-items');
    if (items) {
      items.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-key]');
        if (!btn) return;
        MMCart.change(btn.getAttribute('data-key'), parseInt(btn.getAttribute('data-q'), 10));
      });
    }

    var cartIcon = document.querySelector('.mm-header__icon[aria-label="Sacola de compras"]');
    if (cartIcon) {
      cartIcon.addEventListener('click', function (e) {
        e.preventDefault();
        MMCart.refresh(true).catch(function () { window.location.href = cartIcon.href; });
      });
    }

    document.querySelectorAll('form[data-ajax-cart]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        MMCart.add(form, form.querySelector('[type="submit"]'));
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !d.hidden) MMCart.close();
    });
  }

  function initZoom() {
    var targets = document.querySelectorAll('[data-zoom-src]');
    if (!targets.length) return;
    function openZoom(src) {
      var ov = document.createElement('div');
      ov.className = 'mm-zoom';
      ov.innerHTML = '<img src="' + esc(src) + '" alt=""><button type="button" class="mm-zoom__close" aria-label="Fechar">&times;</button>';
      function closeZoom() {
        ov.remove();
        document.body.style.overflow = '';
        document.removeEventListener('keydown', onKey);
      }
      function onKey(e) { if (e.key === 'Escape') closeZoom(); }
      ov.addEventListener('click', closeZoom);
      document.addEventListener('keydown', onKey);
      document.body.appendChild(ov);
      document.body.style.overflow = 'hidden';
      ov.querySelector('.mm-zoom__close').focus();
    }
    Array.prototype.forEach.call(targets, function (el) {
      el.addEventListener('click', function () {
        openZoom(el.getAttribute('data-zoom-src') || (el.querySelector('img') && el.querySelector('img').src));
      });
    });
  }

  function initRecentlyViewed() {
    var KEY = 'mm_recent_products';
    var list = [];
    try { list = JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { list = []; }

    var currentEl = document.getElementById('mm-current-product');
    var current = null;
    if (currentEl) {
      try { current = JSON.parse(currentEl.textContent); } catch (e) { current = null; }
    }
    if (current && current.url) {
      list = list.filter(function (p) { return p.url !== current.url; });
      list.unshift(current);
      if (list.length > 12) list = list.slice(0, 12);
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    }

    var track = document.getElementById('mm-recent-track');
    var section = document.getElementById('mm-recent');
    if (!track || !section) return;

    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'BRL';
    function money(cents) {
      if (cents == null) return '';
      try { return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: currency }).format(cents / 100); }
      catch (e) { return 'R$ ' + (cents / 100).toFixed(2); }
    }

    var items = list.filter(function (p) { return !current || p.url !== current.url; });
    if (!items.length) return;

    var html = '';
    items.forEach(function (p) {
      html += '<div class="mm-products__item"><article class="mm-card">'
        + '<a href="' + esc(p.url) + '" class="mm-card__media">' + (p.image ? '<img class="mm-card__img" src="' + esc(p.image) + '" alt="" loading="lazy">' : '') + '</a>'
        + '<div class="mm-card__info">'
        + '<h3 class="mm-card__title"><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></h3>'
        + '<div class="mm-card__prices">'
        + '<span class="mm-card__price">' + money(p.price) + '</span>'
        + (p.compare && p.compare > p.price ? '<s class="mm-card__compare">' + money(p.compare) + '</s>' : '')
        + '</div></div></article></div>';
    });
    track.innerHTML = html;
    section.hidden = false;
  }

  function initInfiniteScroll() {
    var grid = document.querySelector('[data-infinite-grid]');
    if (!grid) return;
    var sentinel = document.querySelector('[data-infinite-sentinel]');
    var btn = document.querySelector('[data-infinite-button]');
    var loading = false;

    function loadNext() {
      var next = grid.getAttribute('data-next-url');
      if (!next || loading) return;
      loading = true;
      if (btn) btn.textContent = 'Carregando...';
      fetch(next)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-infinite-grid]');
          if (newGrid) {
            Array.prototype.slice.call(newGrid.children).forEach(function (c) { grid.appendChild(c); });
            var nextUrl = newGrid.getAttribute('data-next-url');
            grid.setAttribute('data-next-url', nextUrl || '');
            if (!nextUrl) {
              if (btn) btn.remove();
              if (sentinel) sentinel.remove();
            }
          }
          loading = false;
          if (btn) btn.textContent = 'Carregar mais';
        })
        .catch(function () {
          loading = false;
          if (btn) btn.textContent = 'Carregar mais';
        });
    }

    if (btn) btn.addEventListener('click', loadNext);
    if (sentinel && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) loadNext(); });
      }, { rootMargin: '600px' }).observe(sentinel);
    }
  }

  // Filtros da categoria: no celular viram uma faixa compacta (um painel aberto por vez);
  // no desktop ficam como lista lateral, todos abertos.
  function initFilterBar() {
    var bar = document.querySelector('[data-filter-bar]');
    if (!bar) return;
    var mq = window.matchMedia('(max-width: 989px)');
    var items = Array.prototype.slice.call(bar.querySelectorAll('.mm-coll__filter'));
    function closeAll(except) {
      items.forEach(function (d) { if (d !== except) d.open = false; });
    }
    function sync() {
      items.forEach(function (d) { d.open = !mq.matches; });
    }
    sync();
    bar.classList.add('is-ready');
    if (mq.addEventListener) mq.addEventListener('change', sync);
    else if (mq.addListener) mq.addListener(sync);
    items.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (mq.matches && d.open) closeAll(d);
      });
    });
    document.addEventListener('click', function (e) {
      if (mq.matches && !bar.contains(e.target)) closeAll();
    });
    document.addEventListener('keydown', function (e) {
      if (mq.matches && e.key === 'Escape') closeAll();
    });
  }

  function initShippingEstimator() {
    var box = document.querySelector('[data-shipping-estimator]');
    if (!box) return;
    var input = box.querySelector('[data-ship-cep]');
    var btn = box.querySelector('[data-ship-btn]');
    var result = box.querySelector('[data-ship-result]');
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'BRL';

    function money(v) {
      try { return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: currency }).format(v); }
      catch (e) { return 'R$ ' + v.toFixed(2); }
    }
    function msg(text, isError) {
      result.hidden = false;
      result.innerHTML = '<p class="mm-ship__msg' + (isError ? ' mm-ship__msg--error' : '') + '">' + text + '</p>';
    }

    input.addEventListener('input', function () {
      var v = input.value.replace(/\D/g, '').slice(0, 8);
      if (v.length > 5) v = v.slice(0, 5) + '-' + v.slice(5);
      input.value = v;
    });

    function render(rates) {
      if (!rates || !rates.length) { msg('Nenhuma opção de frete encontrada para este CEP.', true); return; }
      var html = '';
      rates.forEach(function (r) {
        var price = parseFloat(r.price);
        var priceTxt = price > 0 ? money(price) : 'Grátis';
        var eta = '';
        if (r.delivery_days && r.delivery_days.length) {
          var d = r.delivery_days;
          eta = d.length > 1 ? (d[0] + '–' + d[d.length - 1] + ' dias úteis') : (d[0] + ' dias úteis');
        }
        html += '<div class="mm-ship__rate"><span><span class="mm-ship__rate-name">' + esc(r.name) + '</span>'
          + (eta ? '<span class="mm-ship__rate-eta"> · ' + eta + '</span>' : '')
          + '</span><span class="mm-ship__rate-price">' + priceTxt + '</span></div>';
      });
      result.hidden = false;
      result.innerHTML = html;
    }

    function poll(tries) {
      tries = tries || 0;
      return fetch(route('cart/async_shipping_rates.json'), { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var data = null;
          try { data = JSON.parse(text); } catch (e) { data = null; }
          if (data === null) {
            if (tries < 12) return new Promise(function (res) { setTimeout(res, 500); }).then(function () { return poll(tries + 1); });
            msg('Não foi possível calcular agora. Tente novamente.', true);
            return;
          }
          render(Array.isArray(data) ? data : (data.shipping_rates || []));
        });
    }

    function estimate() {
      var cep = (input.value || '').replace(/\D/g, '');
      if (cep.length !== 8) { msg('Digite um CEP válido (8 dígitos).', true); return; }
      btn.disabled = true;
      msg('Calculando...');
      var body = 'shipping_address[zip]=' + encodeURIComponent(cep) + '&shipping_address[country]=Brazil';
      fetch(route('cart/prepare_shipping_rates.json'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
        body: body
      })
        .then(function () { return poll(); })
        .catch(function () { msg('Erro ao calcular o frete. Tente novamente.', true); })
        .then(function () { btn.disabled = false; });
    }

    btn.addEventListener('click', estimate);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); estimate(); }
    });
  }

  function initSizeGuide() {
    var modal = document.getElementById('mm-sizeguide');
    if (!modal) return;
    var closeTimer;
    function open() {
      window.clearTimeout(closeTimer);
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      window.requestAnimationFrame(function () { modal.classList.add('is-open'); });
    }
    function close() {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
      closeTimer = window.setTimeout(function () { modal.hidden = true; }, 250);
    }
    document.querySelectorAll('[data-sizeguide-open]').forEach(function (b) {
      b.addEventListener('click', open);
    });
    modal.querySelectorAll('[data-sizeguide-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
  }

  function init() {
    shuffleItems();
    initReveal();
    initHeader();
    initMobileMenu();
    initHeroVideo();
    initCart();
    MMSuggest.init();
    initZoom();
    initInfiniteScroll();
    initFilterBar();
    initRecentlyViewed();
    initSizeGuide();
    initShippingEstimator();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', initReveal);
})();
